import type { Workspace } from '@/providers/workspace-provider'

/** Additive toggle for global activeWorkspaceIds (sidebar scope). Click adds/removes; use selectOnlyWorkspace for sole select. */
export function handleAdditiveWorkspaceScopeToggle(
  workspaceId: string,
  activeWorkspaceIds: string[],
  toggleWorkspace: (id: string) => void,
): void {
  toggleWorkspace(workspaceId)
}

export function selectOnlyWorkspace(
  workspaceId: string,
  setActiveWorkspaceIds: (ids: string[]) => void,
): void {
  setActiveWorkspaceIds([workspaceId])
}

/** Radio + multi-select toggle for global activeWorkspaceIds (sidebar scope). */
export function handleActiveWorkspaceScopeToggle(
  workspaceId: string,
  multi: boolean,
  activeWorkspaceIds: string[],
  workspaces: Workspace[],
  toggleWorkspace: (id: string) => void,
  setActiveWorkspaceIds: (ids: string[]) => void,
): void {
  if (multi) {
    toggleWorkspace(workspaceId)
    return
  }
  const isSole =
    activeWorkspaceIds.length === 1 && activeWorkspaceIds[0] === workspaceId
  if (isSole) {
    setActiveWorkspaceIds(workspaces.map((w) => w.id))
  } else {
    setActiveWorkspaceIds([workspaceId])
  }
}

export function restoreAllWorkspaces(
  workspaces: Workspace[],
  setActiveWorkspaceIds: (ids: string[]) => void,
): void {
  setActiveWorkspaceIds(workspaces.map((w) => w.id))
}
